import Actions from "./Actions";
import AdminService from "../../services/AdminService";

const adminService = new AdminService();

const getDashboardWidgetData = () => {
    return (dispatch) => {
        dispatch({type: Actions.DASHBOARD_REQUEST});

        adminService.getDashboardWidgetData((err, response) =>{
            if(err){
                dispatch({
                    type: Actions.DASHBOARD_FAIL
                });
            }else{
                dispatch({
                    type: Actions.DASHBOARD_SUCCESS,
                    payload: response
                });
            }
        });
    };
};

export {getDashboardWidgetData};